import { Amplify } from 'aws-amplify';
import { ENV } from './env';
import { registerAmplifyTokenRefresher } from './amplifyTokenRefresher';

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: ENV.cognito.userPoolId,
      userPoolClientId: ENV.cognito.clientId,
      signUpVerificationMethod: 'code' as const,
      loginWith: {
        email: true,
        oauth: {
          domain: ENV.cognito.domain.replace('https://', ''),
          scopes: ['aws.cognito.signin.user.admin', 'openid', 'email'],
          redirectSignIn: [ENV.cognito.redirectSignIn],
          redirectSignOut: [ENV.cognito.redirectSignOut],
          responseType: 'code' as const,
        },
      },
    },
  },
};

export const configureAmplify = () => {
  Amplify.configure(amplifyConfig);
  registerAmplifyTokenRefresher();
};

export default amplifyConfig;
